import { BaseModal, BaseModalProps } from './BaseModal';
import { useModal } from '../../contexts/ModalContext';
import { TableWidget, TableWidgetColumns } from '../widgets/TableWidget';
import { TabControls } from '../common/tabs/TabControls';
import { SyntheticEvent, useState } from 'react';
export default function AbsencesModal({ name }: BaseModalProps) {
  const columnsApprovedAttendances: TableWidgetColumns[] = [
    {
      name: 'Datum',
      id: 'date',
      columnSpan: 1,
    },
    {
      name: 'Frånvaro/Närvaro',
      id: 'typeName',
      columnSpan: 1,
    },
    {
      name: 'Tid',
      id: 'hoursToExport',
      columnSpan: 1,
    },
    {
      name: 'Omfattning',
      id: 'extent',
      columnSpan: 1,
    },
    {
      name: 'Typ',
      id: 'reportType',
      columnSpan: 1,
    },
    {
      name: '',
      id: 'fillerColumn',
      columnSpan: 1,
    },
  ];

  const columnsNotApprovedAttendances: TableWidgetColumns[] = [
    {
      name: 'Datum',
      id: 'date',
      columnSpan: 1,
    },
    {
      name: 'Frånvaro/Närvaro',
      id: 'typeName',
      columnSpan: 1,
    },
    {
      name: 'Tid',
      id: 'hoursToExport',
      columnSpan: 1,
    },
    {
      name: 'Omfattning',
      id: 'extent',
      columnSpan: 1,
    },
    {
      name: 'Typ',
      id: 'reportType',
      columnSpan: 1,
    },
    {
      name: 'Anledning',
      id: 'reasonOfIncompletion',
      columnSpan: 1,
    },
  ];

  const { modalState } = useModal();
  const [activeTabValue, setActiveTabValue] = useState(0);

  const period = modalState.AbsencesModal.payload.period;

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setActiveTabValue(newValue);
  };

  return (
    <BaseModal
      title={`Löneunderlag`}
      name="AbsencesModal"
      subtitle={`${modalState.AbsencesModal.payload.name} \n ${period}`}
    >
      <TabControls
        tabValue={activeTabValue}
        tabs={['Godkända', 'Icke godkänt']}
        handleChangeTabs={handleChangeTabs}
      />
      {activeTabValue === 0 && (
        <TableWidget
          data={modalState.AbsencesModal.payload.absencesUi.concat(
            modalState.AbsencesModal.payload.timeReportsUi
          )}
          columns={columnsApprovedAttendances}
          isScrollable
        />
      )}
      {activeTabValue === 1 && (
        <TableWidget
          data={modalState.AbsencesModal.payload.incompleteScheduledTasks.concat(
            modalState.AbsencesModal.payload.incompleteAbsences
          )}
          columns={columnsNotApprovedAttendances}
          isScrollable
        />
      )}
    </BaseModal>
  );
}
